import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import Register from './components/Register';
import Login from './components/Login';
import LeaveForm from './components/LeaveForm';
import LeaveList from './components/LeaveList';
import Navbar from './components/Navbar';
import ProfessorDashboard from './components/ProfessorDashboard';
import HomePage from './components/HomePage';
import AdminDashboard from './components/AdminDashboard';
const App = () => {
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (error) {
        console.error('Failed to decode token:', error);
        setAuthToken(null);
      }
    } else {
      setUser(null);
    }
  }, [token]);

  const setAuthToken = (newToken) => {
    if (newToken) {
      localStorage.setItem('token', newToken);
      setToken(newToken);
    } else {
      localStorage.removeItem('token');
      setToken(null);
    }
  };

  return (
    <Router>
      <Navbar token={token} setToken={setAuthToken} user={user} />
      <Routes>
      <Route path="/home" element={<HomePage />} />

        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/register" element={<Register setToken={setAuthToken} />} />
        <Route path="/login" element={<Login setToken={setAuthToken} />} />
        <Route
          path="/apply-leave"
          element={token ? <LeaveForm token={token} /> : <Navigate to="/login" />}
        />
    <Route
  path="/professor-dashboard"
  element={
    (token && (user?.role === 'professor' || user?.role === 'admin')) ? (
      <ProfessorDashboard token={token} />
    ) : (
      <Navigate to="/login" />
    )
  }
/>
<Route
  path="/admin-dashboard"
  element={
    (token && (user?.role === 'professor' || user?.role === 'admin')) ? (
      <AdminDashboard token={token} />
    ) : (
      <Navigate to="/login" />
    )
  }
/>
        <Route
          path="/leaves"
          element={token ? <LeaveList token={token} /> : <Navigate to="/login" />}
        />
      </Routes>
    </Router>
  );
};

export default App;